import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("sw_user");
      return raw ? JSON.parse(raw) : null;
    } catch (err) {
      console.warn("AuthContext: failed to parse stored user", err);
      return null;
    }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("sw_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api.get("/auth/me").then((r) => {
      setUser(r.data);
      localStorage.setItem("sw_user", JSON.stringify(r.data));
    }).catch((err) => {
      console.warn("AuthContext: token validation failed", err?.response?.status);
      localStorage.removeItem("sw_token");
      localStorage.removeItem("sw_user");
      setUser(null);
    }).finally(() => setLoading(false));
  }, []);

  const login = useCallback((token, u) => {
    localStorage.setItem("sw_token", token);
    localStorage.setItem("sw_user", JSON.stringify(u));
    setUser(u);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("sw_token");
    localStorage.removeItem("sw_user");
    setUser(null);
  }, []);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      localStorage.setItem("sw_user", JSON.stringify(r.data));
    } catch (err) {
      console.warn("AuthContext: refresh failed", err?.response?.status);
    }
  }, []);

  const value = useMemo(
    () => ({ user, login, logout, refresh, loading }),
    [user, login, logout, refresh, loading]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
